import React from "react";
import { LOGO_URL, CONTACT, NAV_LINKS } from "@/data/content";

export default function Footer() {
    return (
        <footer
            data-testid="footer"
            className="bg-cream text-navy border-t-4 border-navy"
        >
            <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-14 grid md:grid-cols-3 gap-10 items-start">
                <div>
                    <img
                        src={LOGO_URL}
                        alt="Luna Markab"
                        className="h-20 w-auto mb-4"
                    />
                    <p className="text-navy/85 max-w-sm font-medium">
                        Publicitaria de alto impacto, IA creativa y branding
                        memorable desde Guadalajara para el mundo.
                    </p>
                </div>

                <div>
                    <div className="font-display uppercase tracking-widest text-xs text-orange mb-4" style={{ WebkitTextStroke: "0.7px #326d8e" }}>
                        Navegación
                    </div>
                    <ul className="space-y-2">
                        {NAV_LINKS.map((l) => (
                            <li key={l.href}>
                                <a
                                    href={l.href}
                                    className="font-display uppercase tracking-wider text-sm hover:text-orange"
                                >
                                    {l.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <div className="font-display uppercase tracking-widest text-xs text-orange mb-4" style={{ WebkitTextStroke: "0.7px #326d8e" }}>
                        Contacto directo
                    </div>
                    <ul className="space-y-2 text-navy/90 font-medium text-sm">
                        <li>{CONTACT.direccion}</li>
                        <li>
                            Tel.{" "}
                            <a
                                href={`tel:${CONTACT.telefono}`}
                                className="hover:text-orange"
                            >
                                {CONTACT.telefono}
                            </a>
                        </li>
                        <li>
                            <a
                                href={`mailto:${CONTACT.email}`}
                                className="hover:text-orange break-all"
                            >
                                {CONTACT.email}
                            </a>
                        </li>
                        <li>{CONTACT.web}</li>
                    </ul>
                </div>
            </div>

            <div className="border-t-4 border-navy bg-navy text-cream">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-5 flex flex-col md:flex-row gap-3 items-center justify-between font-display uppercase tracking-widest text-xs">
                    <span>
                        © {new Date().getFullYear()} Luna Markab Publicitaria.
                        Todos los derechos reservados.
                    </span>
                    <span className="text-gold">Hecho con energía retro ★</span>
                </div>
            </div>
        </footer>
    );
}
